import { CategoryGuids } from './Category'

export enum RecurrenceTypes {
  Unknown = 0,
  EveryWeek = 1,
  EveryOtherWeek = 2,
  EveryMonth = 3,
  EveryOtherMonth = 4,
  EveryQuarter = 5,
  EveryOtherQuarter = 6,
  EveryYear = 7,
}

export const MainClassGuids = {
  PAYROLL: 'MNC-bfc102ab-d4c3-41a7-9cf6-fdbf2e1ed7ea',
  PAYROLL_QA: 'MNC-cc857751-2758-4f50-bdfe-d1210f40a155',
} as const

export const ALLOWED_MERCHANTLESS_BILL_CATEGORIES = [
  CategoryGuids.MORTGAGE_RENT,
  CategoryGuids.BILLS_AND_UTILITIES,
  CategoryGuids.HOME_PHONE,
  CategoryGuids.INTERNET,
  CategoryGuids.MOBILE_PHONE,
  CategoryGuids.TELEVISION,
  CategoryGuids.UTILITIES,
] as const

export const ALLOWED_MERCHANTLESS_INCOME_MAIN_CLASSES = [
  MainClassGuids.PAYROLL,
  MainClassGuids.PAYROLL_QA,
] as const
